// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */

import * as React from 'react';
import { RepostAction } from '@ta/social.repost-action';
import type { ExternalRepostProps } from '@ta/social.types';

type ShareViaRepostActionProps = {
  itemType: string,
  repostProps: ExternalRepostProps,
};

// RepostAction has been moved from the social action bar into the SharePopover,
// but only in certain components for certain itemTypes.
// Other itemTypes like LocationInformation have not been changed.
// itemTypes like Hotel_Review, Restaurant_Review, etc. on POI detail pages don't allow reposting.
const ShareViaRepostAction = ({ itemType, repostProps }: ShareViaRepostActionProps) => {
  if (itemType === 'Repost') {
    return (
      <RepostAction
        modalName={repostProps.modalName}
        repostPreviewProps={repostProps.repostPreviewProps}
        originalRepostReference={repostProps.originalRepostReference}
        actor={repostProps.actor}
        socialStatistics={repostProps.socialStatistics}
        onClick={repostProps.onClick}
        styleAsShareListItem
        openRepostModalAsLocal
      />
    );
  } else if (
    itemType === 'Video' ||
    itemType === 'Photo' ||
    itemType === 'Review' ||
    itemType === 'LinkPost' ||
    itemType === 'MediaBatch' ||
    itemType === 'ForumPost' ||
    itemType === 'ForumResponse' ||
    itemType === 'NotMyTrip' ||
    itemType === 'ReadTrip' ||
    itemType === 'WriteTrip'
  ) {
    return (
      <RepostAction
        modalName={repostProps.modalName}
        repostPreviewProps={repostProps.repostPreviewProps}
        actor={repostProps.actor}
        socialStatistics={repostProps.socialStatistics}
        onClick={repostProps.onClick}
        styleAsShareListItem
        openRepostModalAsLocal
      />
    );
  }
  return null;
};

export default ShareViaRepostAction;
